import { render } from "./Slider.vue?vue&type=template&id=68a4b788"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"

import "./Slider.vue?vue&type=style&index=0&id=68a4b788&lang=scss"

import exportComponent from "C:\\Work\\Web-Widgets-FinanceJyskeFinans\\FinanceJyskeFinans.Web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__